module.exports = __webpack_public_path__ + "img/alert-circle.6cd5cad3.svg";